module.exports = "https://static.wanderu.com/ui-react/_next/static/media/logo.a177a428.png";